class @App.Clubs.NewClubsApplicationView
  container = $('#clubs-application-form-container')

  constructor: ->
    setUserId()
    setUserName()

  setUserId = ->
    if container.data('current-user')
      $('#clubs_application_applicant_attributes_user_id')
        .val(container.data('current-user'))

  setUserName = ->
    if container.data('current-user-name')
      $('#clubs_application_applicant_attributes_name')
        .val(container.data('current-user-name'))

$ ->
  new App.Clubs.NewClubsApplicationView if $('.clubsApplicationsNewView').length
